(function( $ ) {
	function getWidth(){
		return $('.elementor-section').width();
	}
	function getMoitieWidth(){
		return getWidth() / 2;
	}
	function imgDimension(imageS) {
		imageS.css("width", getMoitieWidth());
		var $imgH = imageS.height();
		imageS.parent().height($imgH);
	}
	$('.imgleft > img').each(function(){
		imgDimension($(this));
	});
	$('.imgright > img').each(function(){
		imgDimension($(this));
	});

	$( ".navbar-toggler" ).click(function() {
		if ($( ".navbar-toggler .navbar-toggler-icon" ).hasClass( "active" )) {
			$( ".navbar-toggler .navbar-toggler-icon" ).removeClass( "active");
		}
		else{
			$( ".navbar-toggler .navbar-toggler-icon" ).addClass( "active");
		}
	});

	//formulaire de pré-commande & commande;

	var $initial_modele = $("button#modele").text();
	var $initial_dimensions = $("button#dimensions").text();
	var $initial_pietements = $("button#pietements").text();
	var $initial_couleur = $("button#couleur").text();
	var $initial_poutres = $("button#poutres").text();
	var $initial_fondements = $("button#fondements").text();

	$(document).on( 'click','.item', function(e) {
		e.preventDefault();
		$("#selections-poroduct button").attr('disabled','disabled');
		$(".ladl_load").show();
		$('.ladl-form-error').hide('slow');
		var $nomtable = $(".input-type").val();
		$("div.input-nomtable").find("input[type=text]").val($nomtable);
		var $item = $(this).text();
		var $slug = $(this).attr( "data-slug" );
		var $selected = $(this).parent().parent().children("button");
		$selected.text($item);
		var $id=$selected.attr('id');
    	$("span.input-"+$id).text($item);
    	$("input.input-"+$id).val($slug);
    	$("div.input-"+$id).find("input[type=text]").val($item);
    	send_slug();
	});

	$(document).on( 'click','.ladl-reset', function(e) {
		e.preventDefault();
		$(".ladl_load").show();
		$('.ladl-form-error').hide('slow');
		var remove = $(this).attr( "data-remove" );
		$(".input-"+remove).val('');
		send_slug();
	});
	$(document).on( 'click','#ladl-reinitialise-filter', function(e) {
		e.preventDefault();
		$(".ladl_load").show();
		$('.ladl-form-error').hide('slow');
		$(".input-modele").val('');
		$(".input-dimensions").val('');
		$(".input-pietements").val('');
		$(".input-couleur").val('');
		$(".input-poutres").val('');
		$(".input-fondements").val('');
		reset_send_slug();
	});

	function reset_send_slug(){
		var nomtable = $(".input-type").val();
		var inputmodele = $(".input-modele").val();
		var inputdimensions = $(".input-dimensions").val();
		var inputpietements = $(".input-pietements").val();
		var inputcouleur = $(".input-couleur").val();
		var inputpoutres = $(".input-poutres").val();
		var inputfondements = $(".input-fondements").val();
		var data = {
		'action': 'my_action',
		'nomtable': nomtable,
		'inputmodele': inputmodele,
		'inputdimensions': inputdimensions,
		'inputpietements': inputpietements,
		'inputcouleur': inputcouleur,
		'inputpoutres': inputpoutres,
		'inputfondements': inputfondements,
		};
		$.post(MyAjax.ajaxurl, data, function(response) {
			//alert('Got this from the server: ' + response);
			$('#selections-poroduct .elementor-shortcode').html(response);
			$(".ladl_load").hide();
			$(".ladl-reinitialise-filter").hide('slow');
		});
	}

	function send_slug(){
		var nomtable = $(".input-type").val();
		var inputmodele = $(".input-modele").val();
		var inputdimensions = $(".input-dimensions").val();
		var inputpietements = $(".input-pietements").val();
		var inputcouleur = $(".input-couleur").val();
		var inputpoutres = $(".input-poutres").val();
		var inputfondements = $(".input-fondements").val();
		var data = {
		'action': 'my_action',
		'nomtable': nomtable,
		'inputmodele': inputmodele,
		'inputdimensions': inputdimensions,
		'inputpietements': inputpietements,
		'inputcouleur': inputcouleur,
		'inputpoutres': inputpoutres,
		'inputfondements': inputfondements,
		};
		$.post(MyAjax.ajaxurl, data, function(response) {
			//alert('Got this from the server: ' + response);
			$('#selections-poroduct .elementor-shortcode').html(response);
			$(".ladl_load").hide();
			$(".ladl-reinitialise-filter").show('slow');
		});
	}

	$(".btn-precommander").click(function() {
		var $modele = $("button#modele").text();
		var $dimensions = $("button#dimensions").text();
		var $pietements = $("button#pietements").text();
		var $couleur = $("button#couleur").text();
		var $poutres = $("button#poutres").text();
		var $fondements = $("button#fondements").text();
		if (($modele!=$initial_modele)&&($dimensions!=$initial_dimensions)&&($pietements!=$initial_pietements)&&($couleur!=$initial_couleur)&&($poutres!=$initial_poutres)&&($fondements!=$initial_fondements)) {
			$("#commande").slideToggle();
			$("#fin-commande").slideToggle();
		}
		else{
			$('.ladl-form-error').show('slow');
		}
		return false;
	});

	$(".ladl_cancel").click(function() {
		$("#fin-commande").slideToggle();
		$("#commande").slideToggle();
	});

	$("#article-plus").click(function() {
		var $initial_page = parseInt($(".input-page").val());
		var $page = $initial_page + 1;
		$(".input-page").val($page);
		send_page_num();
	});

	function send_page_num(){
		var num_page = $(".input-page").val();
		var data = {
		'action': 'recive_page_num',
		'numpage': num_page,
		};
		$.post(MyAjax.ajaxurl, data, function(response) {
			$('#art-plus .row').append(response);
		});
	}

	mobile_thumb();
	$(window).on('resize', function() {
		mobile_thumb();
	});
	function mobile_thumb(){
		if($(window).width() < 575){
			$('div.mobile-thumb').each(function(index, el){
				var img_url = $(el).attr('data-img');
				$(el).html('<img src="'+ img_url +'" alt="mobile-thumb" />');
			});
		}else{
			$('div.mobile-thumb').find('img').remove();
		}
	}

	//carousel commande

	$(document).ready(function() {
        $('.ladl-container').ladl_carousel({
            num: 9,
            maxWidth: 500,
            maxHeight: 407,
            distance: 50,
            scale: 0.6,
            animationTime: 1000,
            showTime: 4000
        });
    });

	$(document).ready(function() {
        $('.others-models').slick({
			slidesToScroll: 1,		
 			infinite: false,
			dots: false,			
			arrows: true,
			variableWidth: true
        });
    });

})( jQuery );